module.exports = __webpack_public_path__ + "static/media/_ME10902.875b273c.jpg";